import { useState } from 'react';
import React from 'react';
import Sidebar from '../Sidebar/Sidebar';
import './TicTacToeGames.css'

export default function VersusHuman () {
  function Grid({value, onSquareClick, gridBackColor }) {
    return (
      <button className="square" onClick={onSquareClick} style={{'backgroundColor': gridBackColor }}>
      {value}
      </button>
    );
  }

  const [grid, setGrid] = useState(Array(9).fill(null));
  const [XisNext, setXisNext] = useState(true);
  const [backColor, setBackColor] = useState(Array(9).fill('#2e80b3'));


  function handleClick(i) {
    if (winningLines(grid) || grid[i]) {
      return;
    }
    const nextClick = grid.slice();
    if (XisNext) {
      nextClick[i] = 'X';
    } else {
      nextClick[i] = 'O';
    }
    setGrid(nextClick);
    setXisNext(!XisNext);
  }

  function winningLines(grid) {
    const lines = [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [0, 3, 6],
    [1, 4, 7],
    [2, 5, 8],
    [0, 4, 8],
    [2, 4, 6],
  ];
    for (let i = 0; i < lines.length; i++) {
    const [a, b, c] = lines[i];
    // si le premier element de grid est different de zero
    if (grid[a] !== null && 
      // si le premier element de grid est egal au deuxieme elt de grid
      grid[a] === grid[b] && 
      // si le premier elmt de grid est egal au troisieme element de grid
      grid[a] === grid[c]) {
        backColor[a]= '#F33418';
        backColor[b]= '#F33418';
        backColor[c]= '#F33418';
      return grid[a];
     }
   }
    return null;
  }

  const winner = winningLines(grid);
  let status;
  if (winner) {
    status = `${winner} a gagné !` ;
  } 
  else if (grid.every(Boolean)) {
    status = 'Match nul!' ;
  }
  else {
    status = `C'est à ${XisNext ? 'X' : 'O'} de jouer.`;
  }

  function Reset() {
    setGrid(Array(9).fill(null));
    setXisNext(true);
    setBackColor(Array(9).fill('#2e80b3'));
  }

  return (
    <section className='TicTacToe_global_section'>
    <div className='TicTacToe_main_section'>
      <h1 className='TicTacToe_game_title'>Morpion</h1>
	  <p className='TicTacToe_game_rule'>Pour gagner la partie, aligne trois symboles identiques.</p>
      <div className='game'>
        <div className="status">{status}</div>    
        <div className='board'>
          <div className="grid_row">
            <Grid value={grid[0]} onSquareClick={() => handleClick(0)} gridBackColor={backColor[0]} />
            <Grid value={grid[1]} onSquareClick={() => handleClick(1)} gridBackColor={backColor[1]}/>
            <Grid value={grid[2]} onSquareClick={() => handleClick(2)} gridBackColor={backColor[2]}/>
          </div>
          <div className="grid_row">
            <Grid value={grid[3]} onSquareClick={() => handleClick(3)} gridBackColor={backColor[3]}/>
            <Grid value={grid[4]} onSquareClick={() => handleClick(4)} gridBackColor={backColor[4]}/>
            <Grid value={grid[5]} onSquareClick={() => handleClick(5)} gridBackColor={backColor[5]}/>
          </div>
          <div className="grid_row">
            <Grid value={grid[6]} onSquareClick={() => handleClick(6)} gridBackColor={backColor[6]}/>
            <Grid value={grid[7]} onSquareClick={() => handleClick(7)} gridBackColor={backColor[7]}/>
            <Grid value={grid[8]} onSquareClick={() => handleClick(8)} gridBackColor={backColor[8]}/>
          </div>
          <div className='morpion_two_buttons'>
            <button className='reset' onClick ={() => Reset()}>Recommencer</button>
            <a href='/morpion-contre-ordinateur'><button className='two_players'>Un joueur</button></a> 
          </div>
        </div>
      </div>
    </div>
    <div>
        <Sidebar/>
    </div>
      </section>
  );
}





